// @flow
import * as React from 'react';
import { StyledSelect } from 'components/Select';

const MultiSelect = ({
  name,
  value,
  options,
  disabled,
  onChange,
  maxSelected = 5,
  ...props
}: {
  name: string,
  value: Array<string>,
  options: Array<{ value: string, label: string }>,
  disabled?: boolean,
  onChange: string => void,
  maxSelected?: number,
  'data-qa-id'?: string
}) => (
  <StyledSelect
    name={name}
    options={
      value && value.length >= maxSelected
        ? options.filter(option => value.includes(option.value))
        : options
    }
    value={value && options.filter(option => value.includes(option.value))}
    isDisabled={disabled}
    onChange={newValues => {
      onChange(newValues.map(v => v.value));
    }}
    isSearchable={!value || (value && !(value.length >= maxSelected))}
    isClearable
    isMulti
    className={props['data-qa-id'] ? `qa-id-${props['data-qa-id']}` : undefined}
    {...props}
  />
);

export default MultiSelect;
